/**
 * Client adapter over the canonical rich-text allow-list shared verbatim with
 * the server sanitizer (`apps/api/core/src/common/sanitize-html.ts`); reshapes
 * it for DOMPurify's flat attribute list.
 */
import {
  RICH_TEXT_ALLOWED_TAGS,
  RICH_TEXT_GLOBAL_ATTRS,
  RICH_TEXT_TAG_ATTRS,
  sanitizeStyleAttribute,
} from "@salestrak/utilities";

export const ALLOWED_TAGS: readonly string[] = RICH_TEXT_ALLOWED_TAGS;

export const ALLOWED_ATTR: readonly string[] = [
  ...new Set([
    ...RICH_TEXT_GLOBAL_ATTRS,
    ...Object.values(RICH_TEXT_TAG_ATTRS).flat(),
  ]),
];

export { sanitizeStyleAttribute };

/**
 * Per-tag attribute scoping for the DOMPurify hook, which has no per-tag
 * allow-list of its own: pins dangerous-to-leak attrs to one tag each,
 * restoring parity with the authoritative server sanitizer.
 */
export const ATTR_TAG_SCOPE: Readonly<Record<string, readonly string[]>> = {
  src: ["IMG"],
  href: ["A"],
  type: ["INPUT"],
  checked: ["INPUT"],
};
